<template>
  <div :style="{ height: height }" class="top">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>绑定谷歌验证码</span>
      </div>
      <div class="text item">
        <span class="status">状态： {{googleVerifyFlag?'已设置':'未设置'}}</span>
        <el-button class="btn" type="primary" size="small" v-if="checkPermission(funcData, 'bind') && !googleVerifyFlag" @click="dialogCheckBind=true" plain>设置</el-button>
        <el-button class="btn" type="danger" size="small" v-if="checkPermission(funcData, 'unbind') && googleVerifyFlag" @click="dialogUnbind=true" plain>解绑</el-button>
        <el-button class="btn" type="success" size="small" v-if="checkPermission(funcData, 'show') && googleVerifyFlag" @click="dialogCheckShow=true" plain>显示二维码</el-button>
      </div>
    </el-card>

    <!-- 检查绑定 -->
    <el-dialog :close-on-click-modal="false" title="绑定谷歌验证器" :visible.sync="dialogCheckBind" width="550px" top="8vh" @closed="loginPwd=''">
      <div style="padding: 0 50px;">
        <el-input type="password" placeholder="请输入登录密码" v-model="loginPwd" autocomplete="off" maxlength="32">
          <template slot="prepend">登录密码</template>
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitCheckGen()" size="small">提 交</el-button>
        <el-button @click="dialogCheckBind=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 绑定 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogBind" width="550px" top="8vh" @closed="googleVerifyCode=''">
      <div slot="title">
        <div style="line-height: 24px; font-size: 18px;">绑定谷歌验证器操作步骤:</div>
        <div style="color: red; margin-top: 5px;">(1:先扫码 2:扫码成功后会生成谷歌验证码,输入验证码绑定)</div>
      </div>

      <div style="padding: 0 50px; text-align: center; line-height: 40px;">
        <div>使用Google Authenticator,获取6位验证码</div>
        <img style="width: 180px; height: 180px;" :src="imgUrl"/>
        <el-input placeholder="请输入谷歌验证码" v-model="googleVerifyCode" autocomplete="off" maxlength="6">
          <template slot="prepend">谷歌验证码</template>
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitBind()" size="small">绑 定</el-button>
        <el-button @click="dialogBind=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 解绑 -->
    <el-dialog :close-on-click-modal="false" title="解绑谷歌验证器" :visible.sync="dialogUnbind" width="550px" top="8vh" @closed="googleVerifyCode=''">
      <div style="padding: 0 50px;">
        <el-input placeholder="请输入谷歌验证码" v-model="googleVerifyCode" autocomplete="off" maxlength="6">
          <template slot="prepend">谷歌验证码</template>
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitUnbind()" size="small">提 交</el-button>
        <el-button @click="dialogUnbind=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 显示二维码 -->
    <el-dialog :close-on-click-modal="false" title="校验谷歌验证器" :visible.sync="dialogCheckShow" width="550px" top="8vh" @closed="googleVerifyCode=''">
      <div style="padding: 0 50px;">
        <el-input placeholder="请输入谷歌验证码" v-model="googleVerifyCode" autocomplete="off" maxlength="6">
          <template slot="prepend">谷歌验证码</template>
        </el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSubmitShow()" size="small">提 交</el-button>
        <el-button @click="dialogCheckShow=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 显示二维码 -->
    <el-dialog :close-on-click-modal="false" title="显示谷歌验证器二维码" :visible.sync="dialogShow" width="550px" top="8vh">

      <div style="padding: 0 50px; text-align: center; line-height: 40px;">
        <div>使用Google Authenticator扫码添加验证器</div>
        <img style="width: 180px; height: 180px;" :src="imgUrl"/>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogShow=false" size="small">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import rsa from '@/utils/rsa'
export default {
  data () {
    return {
      height: window.innerHeight - 200 + 'px',
      funcData: [], // 权限数据
      dialogCheckBind: false,
      dialogUnbind: false,
      dialogBind: false,
      dialogCheckShow: false,
      dialogShow: false,
      loginPwd: '',
      googleVerifyCode: '',
      googleVerifyFlag: false,
      imgUrl: ''
    }
  },
  mounted () {
    // this.getMerchInfo()
    this.getGoogleFlag()
    this.getFuncData()
  },
  methods: {
    getGoogleFlag () {
      axios({
        url: this.baseUrl + '/googleFlag',
        method: 'get'
      }).then(res => {
        if (res.data.code === '0000') {
          this.googleVerifyFlag = res.data.data
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    onSubmitCheckGen () {
      axios({
        url: this.baseUrl + '/sys/security/generate',
        method: 'post',
        data: { loginPwd: rsa.rsaPublicData(this.loginPwd) }
      }).then(res => {
        if (res.data.code === '0000') {
          this.imgUrl = res.data.data
          this.dialogCheckBind = false
          this.dialogBind = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    onSubmitBind () {
      axios({
        url: this.baseUrl + '/sys/security/bind',
        method: 'post',
        data: { googleVerifyCode: this.googleVerifyCode }
      }).then(res => {
        if (res.data.code === '0000') {
          let flag = res.data.data
          if (flag) {
            this.dialogBind = false
            this.googleVerifyFlag = true
            this.$message.success('绑定成功')
          }
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    onSubmitUnbind () {
      axios({
        url: this.baseUrl + '/sys/security/unbind',
        method: 'post',
        data: { googleVerifyCode: this.googleVerifyCode }
      }).then(res => {
        if (res.data.code === '0000') {
          let flag = res.data.data
          if (flag) {
            this.dialogUnbind = false
            this.googleVerifyFlag = false
            this.$message.success('解绑成功')
          }
        }
      }).catch(err => {
        console.log(err, 'loginerr')
      })
    },
    onSubmitShow () {
      axios({
        url: this.baseUrl + '/sys/security/show',
        method: 'post',
        data: { googleVerifyCode: this.googleVerifyCode }
      }).then(res => {
        if (res.data.code === '0000') {
          this.imgUrl = res.data.data
          this.dialogCheckShow = false
          this.dialogShow = true
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
div.top {
  margin: 20px;
}
span.status {
  margin-right: 100px;
}
.el-dialog__header {
  border-bottom: #cccccc solid 1px;
}
.el-image-viewer__close {
  top: 80px;
}
</style>
